module.exports = __webpack_public_path__ + "static/media/bg-video.5129609d.mp4";